/**
 * Header shrink hysteresis for Prestige is-solid (IntersectionObserver).
 * Prevents flip-flop at the sentinel boundary and scroll-anchoring feedback.
 */
(function () {
  'use strict';

  var ENTER_Y = 48;
  var EXIT_Y = 8;
  var MIN_EXPANDED = 100;

  function init() {
    var header = document.querySelector('x-header.header, .header');
    if (!header) return;

    var section = header.closest('.shopify-section--header');
    var heightObserver = section && section.querySelector('height-observer[variable="header"]');
    var hasTransparentHero = !!document.querySelector(
      '.shopify-section:first-child [allow-transparent-header]'
    );
    var solid = header.classList.contains('is-solid');
    var applying = false;

    function getFlowSpacer() {
      var spacer = document.getElementById('zellij-header-flow-spacer');
      if (spacer || !section) return spacer;
      spacer = document.createElement('div');
      spacer.id = 'zellij-header-flow-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      spacer.style.height = '0';
      spacer.style.pointerEvents = 'none';
      section.insertAdjacentElement('afterend', spacer);
      return spacer;
    }

    /* Spacer sits in body flow (scheme-1 beige). Paint it like the header
       so the reserved strip never flashes body background under the bar. */
    function syncSpacerFill(spacer) {
      if (!spacer || !header) return;
      var bg = getComputedStyle(header).backgroundColor;
      spacer.style.backgroundColor = bg && bg !== 'rgba(0, 0, 0, 0)' ? bg : '#fff';
    }

    function captureExpandedHeight() {
      if (!heightObserver || header.classList.contains('is-solid')) return;
      var h = heightObserver.getBoundingClientRect().height;
      if (h < MIN_EXPANDED) return;
      document.documentElement.style.setProperty('--header-height-expanded', h.toFixed(2) + 'px');
    }

    function syncReservedHeight() {
      if (!heightObserver) return;
      var spacer = getFlowSpacer();
      if (header.classList.contains('is-solid')) {
        heightObserver.style.minHeight = '';
        if (spacer) {
          var expanded = parseFloat(
            document.documentElement.style.getPropertyValue('--header-height-expanded')
          );
          var compact = header.getBoundingClientRect().height;
          if (expanded > compact) {
            spacer.style.height = (expanded - compact).toFixed(2) + 'px';
          } else {
            spacer.style.height = '0';
          }
          syncSpacerFill(spacer);
        }
        return;
      }
      heightObserver.style.minHeight = '';
      if (spacer) {
        spacer.style.height = '0';
        syncSpacerFill(spacer);
      }
    }

    function applySolid(next) {
      if (next === solid) return;
      applying = true;
      if (next && !solid) captureExpandedHeight();
      solid = next;
      header.classList.toggle('is-solid', solid);
      syncReservedHeight();
      applying = false;
    }

    function syncFromScroll() {
      var y = window.scrollY;
      if (hasTransparentHero && y <= EXIT_Y) {
        applySolid(false);
        return;
      }
      if (!solid && y >= ENTER_Y) applySolid(true);
      else if (solid && y <= EXIT_Y) applySolid(false);
    }

    new MutationObserver(function () {
      if (applying) return;
      var ioSolid = header.classList.contains('is-solid');
      if (ioSolid !== solid) {
        header.classList.toggle('is-solid', solid);
        syncReservedHeight();
      }
    }).observe(header, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('scroll', syncFromScroll, { passive: true });
    captureExpandedHeight();
    syncReservedHeight();
    if (window.ResizeObserver && heightObserver) {
      new ResizeObserver(function () {
        captureExpandedHeight();
        syncReservedHeight();
      }).observe(heightObserver);
    }
    syncFromScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
